import { BackgroundConfig } from '@common/shared/form-controls/background-selector/background-list';

export const GRADIENT_LIST: BackgroundConfig[] = [
  {
    configId: 'grd1',
    backgroundImage: 'linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)',
  },
  {
    configId: 'grd2',
    backgroundImage: 'linear-gradient(to right, #ff8177 0%, #ff867a 0%, #ff8c7f 21%, #f99185 52%, #cf556c 78%, #b12a5b 100%)',
  },
  {
    configId: 'grd3',
    backgroundImage: 'linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%)',
  },
  {
    configId: 'grd4',
    backgroundImage: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%)',
  },
  {
    configId: 'grd5',
    backgroundImage: 'linear-gradient(to top, #30cfd0 0%, #330867 100%)',
    color: '#fff',
  },
  {
    configId: 'grd6',
    backgroundImage: 'linear-gradient(135deg, #FDEB71 10%, #F8D800 100%)',
  },
  {
    configId: 'grd7',
    backgroundImage: 'linear-gradient( 135deg, #F05F57 10%, #360940 100%)',
  },
  {
    configId: 'grd8',
    color: '#4158D0',
    backgroundImage: 'linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)',

  },
  {
    configId: 'grd9',
    color: '#FBAB7E',
    backgroundImage: 'linear-gradient(62deg, #FBAB7E 0%, #F7CE68 100%)',
  },
  {
    configId: 'grd10',
    color: '#21D4FD',
    backgroundImage: 'linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)',
  },
  {
    configId: 'grd11',
    backgroundImage: 'linear-gradient( 109.5deg,  rgba(76,221,242,1) 11.2%, rgba(92,121,255,1) 91.1% )',
  },
  {
    configId: 'grd12',
    backgroundImage: 'linear-gradient( 112.1deg,  rgba(32,38,57,1) 11.4%, rgba(63,76,119,1) 70.2% )',
    color: '#fff',
  }
];
